import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  checkPhoneNo(phoneNo: string): boolean {
    if (phoneNo.trim().length != 10 || this.itis(phoneNo, '0'))
      return false
    return (phoneNo.substr(0, 2).localeCompare("09") == 0 ||
      phoneNo.substr(0, 2).localeCompare("08") == 0 ||
      phoneNo.substr(0, 2).localeCompare("06") == 0
    )
  }

  checkPolicy(policy: string): boolean {
    if (policy.trim().length != 8)
      return false
    return true
  }

  checkIDCard(idCard: string): boolean {
    if (idCard.trim().length != 13)
      return false
    return true
  }

  checkFirstName(firstName: string): boolean {
    if (firstName.trim().length > 30)
      return false
    return true
  }

  checkLastName(lastName: string): boolean {
    if (lastName.trim().length > 30)
      return false
    return true
  }

  checkNumber(value: string): boolean {
    let result = value.replace(/\D/g, "");
    if (result) {
      return true;
    } else {
      return false;
    }
  }

  checkUpperLowerCase(value: string): boolean {
    if (value == value.toUpperCase()) {
      return false;
    } else if (value == value.toUpperCase()) {
      return false;
    } else {
      return true;
    }
  }

  keyUpIdCard(value: string): string {
    let idCard = '';
    if (value != '' && value != null && value != undefined) {
      idCard = idCard + value.substr(0, 1) + '-';
      idCard = idCard + value.substr(1, 4) + '-';
      idCard = idCard + value.substr(5, 5) + '-';
      idCard = idCard + value.substr(10, 2) + '-';
      idCard = idCard + value.substr(12, 1)
    }
    return idCard;
  }

  idCardFormat(value: string): string {
    var curchr = value.length;
    var curval = value;
    var curret = '';
    if (curchr == 1) {
      curret = curval + "-"
    } else if (curchr == 6) {
      curret = curval + "-"
    } else if (curchr == 12) {
      curret = curval + "-"
    } else if (curchr == 15) {
      curret = curval + "-"
    } else if (curchr > 17) {
      curret = curval.substr(0, 17)
    } else {
      curret = curval
    }
    return curret;
  }

  idCardReturnFormat(value: string): string {
    let rs = ''
    if (value != '' && value != null && value != undefined) {
      rs = value.split('-').join('')
    }
    return rs;
  }

  dateFormat(d: string, f: string): string {
    let rs = ''
    if (f == 'YYYYMMDD') {
      rs += d.substr(6, 2) + '/';
      rs += d.substr(4, 2) + '/';
      rs += d.substr(0, 4);
    } else {
      rs = d
    }
    return rs;
  }

  itis(s: string, c: string): boolean {
    let l: Number
    if ((l = s.length) == 0) return false
    let i = 0
    for (; i < l && c == s.charAt(i); i++)
      return (i < l ? false : true)
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  changeFile(file: any): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  checkHaveValue(value: any): string {
    if (value === '' || value == null || value === undefined) {
      return '-';
    } else {
      return value;
    }
  }
}
